// extracted by mini-css-extract-plugin
export default {"root":"ModalChooseFormat_root__J7Lvi","text":"ModalChooseFormat_text__6Pevz","tick":"ModalChooseFormat_tick__Af2DW"};